module.exports = __webpack_public_path__ + "img/logo.ba1b2045.png";